import { useState } from "react";
import Input from "../components/input";
import { Link } from "react-router-dom";
import Button from "../components/button";
import api from "../utils/api";
import Snackbar from "../components/snackbar";

const Login = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [snackbar, setSnackbar] = useState({ message: '', visible: false });

    const handleEmailChange = (e) => setEmail(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);

    const handleLogin = () => {

        setIsLoading(true);

        api.post('/login', {
            email,
            password
        })
        .then(res => {
            localStorage.setItem('token', res.data.access_token);
            localStorage.setItem('profile', res.data.user.profile);
            window.location.href = '/dash';
        })
        .catch(err => {
            setIsLoading(false);
            setSnackbar({
                message: 'E-mail ou senha inválidos!',
                visible: true,
            });
        })

    }

    return (
        <>
            <div className="flex items-center justify-center" style={{ minHeight: 'inherit' }}>
                <div className="w-full max-w-xl mx-auto p-4">
                    <h1 className="text-3xl font-bold text-center mb-4">Entrar</h1>

                    <div className="mb-4">
                        <Input
                            fullWidth
                            label="E-mail"
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="Seu e-mail"
                        />
                    </div>
                        
                    <div className="mb-4">
                        <Input 
                            fullWidth
                            label="Senha"
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            placeholder="Sua senha"
                        />
                    </div>
                    
                    {/* Link "Esqueceu a senha" alinhado à direita e mais delicado */}
                    <p className="text-sm text-gray-500 text-right mb-4 hover:text-blue-500">
                        <Link to="/forgot-password">Esqueceu a senha?</Link>
                    </p>
                        
                    <Button 
                        disabled={!email || !password}
                        isLoading={isLoading}
                        onClick={handleLogin}
                        fullWidth
                    >
                        Entrar
                    </Button>
                </div>
            </div>
            {snackbar.visible && (
                <Snackbar
                    message={snackbar.message}
                    type="error"
                    onClose={() => setSnackbar({ ...snackbar, visible: false })}
                />
            )}
        </>
    );
};

export default Login;
